import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AppPhase, SupervisorAction, SupervisorSubPhase, WorkerAccessLevel } from '../../../models/communication/app-enums.model';
import { FlagsState, Game, SupervisorState } from '../../../models/communication/app-state.model';
import { SupervisorPanelComponent } from '../supervisor-panel/supervisor-panel.component';

/**
 * Showing a correct {@link SupervisorPanelComponent}
 * based on the provided state (`supervisorState.subPhase` and `supervisorState.selectedAction`).
 *
 * The panels are used to inform the supervisor about the different states of the app,
 * mostly to confirm the previously selected action.
 */
@Component({
    selector: 'app-supervisor-confirm-panels',
    standalone: true,
    imports: [CommonModule, SupervisorPanelComponent],
    templateUrl: './supervisor-confirm-panels.component.html'
})
export class SupervisorConfirmPanelsComponent {
    @Input()
    supervisorState?: SupervisorState;

    @Input()
    currentGame?: Game;

    @Input()
    flagsState: FlagsState = {};

    @Output()
    readonly cancelActionClicked = new EventEmitter();

    @Output()
    readonly confirmSupervisorAction = new EventEmitter();

    protected readonly AppPhase = AppPhase;
    protected readonly WorkerAccessLevel = WorkerAccessLevel;
    protected readonly SupervisorSubPhase = SupervisorSubPhase;
    protected readonly SupervisorAction = SupervisorAction;

    // Prepare the dynamic titles as i18n can't handle them as string attributes in templates.
    // https://angular.dev/guide/i18n/prepare

    get titleCloseTable(): string {
        return $localize`Closing ${this.currentGame?.displayName}`;
    }

    get titleConfirmGameSelection(): string {
        return $localize`Selected game: ${this.supervisorState?.selectedGame?.displayName}`;
    }

    get titleVoidGame(): string {
        return $localize`Voiding game${this.flagsState.changeShoeRequested ? ' and change shoe' : ''}`;
    }

    get titleFreeHand(): string {
        return $localize`Freeing hand${this.flagsState.changeShoeRequested ? ' and change shoe' : ''}`;
    }
}
